import React, { useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import Icon from '../Icon';
import Dropdown from '../Dropdown';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import {
  setSelectedDeliveryAddress,
  setUseDropshipping,
  setSelectedDropshipAddressType,
  setCustomerDetails,
} from '../../Actions/Checkout.action';
import RadioButton from '../Inputs/Radiobutton';
import CheckoutCustomerInfoForm from './Checkout.CustomerInfoForm';
import {
  CHECKOUT_DROPSHIP_COMPANY,
  CHECKOUT_DROPSHIP_PRIVATE,
} from '../../constants';

const BusinessCustomerInfo = () => {
  const dispatch = useDispatch();
  const { payload } = useTypedSelector((state) => state.checkout);
  const {
    deliveryAddresses,
    allowDropshipping,
    useDropshipping,
    selectedDropshipAddressType = CHECKOUT_DROPSHIP_PRIVATE,
  } = payload;

  const selectedDeliveryAddress = useMemo(
    () =>
      deliveryAddresses.find(
        (a) => a.systemId == payload.selectedDeliveryAddressId
      ),
    [deliveryAddresses, payload.selectedDeliveryAddressId]
  );

  return (
    <div>
      {allowDropshipping && (
        <div className="mb-6 flex flex-col gap-4">
          <RadioButton
            checked={!useDropshipping}
            name="address-type"
            label={translate(
              'checkout.address-type.choose-from-my-addresses'
            )}
            onChange={() =>
              useDropshipping && dispatch(setUseDropshipping(false))
            }
          />
          <RadioButton
            checked={useDropshipping}
            name="address-type"
            label={translate('checkout.address-type.dropship')}
            onChange={() =>
              !useDropshipping && dispatch(setUseDropshipping(true))
            }
          />
        </div>
      )}
      {!useDropshipping && (
        <>
          <div className="mb-4 text-lg font-bold">
            {translate('checkout.selectdelivery')}
          </div>
          <Dropdown
            className="mb-4"
            placeholder={translate('checkout.selectdelivery')}
            selectedValue={payload.selectedDeliveryAddressId}
            options={deliveryAddresses.map((address) => ({
              value: address.systemId,
              label: `${
                !!address.houseExtension
                  ? address.houseExtension
                  : payload.companyName
              }, ${address.address}, ${address.city}, ${
                address.zipCode
              }, ${address.country}`,
            }))}
            onChange={({ value }) => {
              dispatch(setSelectedDeliveryAddress(value));
            }}
            disabled={deliveryAddresses.length <= 1}
          />
          <div className="mb-2 text-lg font-bold">
            {translate('checkout.order.delivery')}
          </div>
          {selectedDeliveryAddress && (
            <div className="flex flex-1 gap-2 rounded bg-gray-100 p-4">
              <Icon name="home-pin" className="h-6 w-6" />
              <div className="flex flex-col gap-2">
                <span className="font-bold">
                  {!!selectedDeliveryAddress.houseExtension
                    ? selectedDeliveryAddress.houseExtension
                    : payload.companyName}
                </span>
                <span>{selectedDeliveryAddress?.address}</span>
                {selectedDeliveryAddress?.address2 && (
                  <span>{selectedDeliveryAddress?.address2}</span>
                )}
                <span>
                  {selectedDeliveryAddress?.zipCode}{' '}
                  {selectedDeliveryAddress?.city}
                </span>
                <span>{selectedDeliveryAddress?.country}</span>
              </div>
            </div>
          )}
        </>
      )}
      {useDropshipping && (
        <>
          <Dropdown
            options={[
              {
                label: translate('checkout.dropship.private'),
                value: CHECKOUT_DROPSHIP_PRIVATE,
              },
              {
                label: translate('checkout.dropship.company'),
                value: CHECKOUT_DROPSHIP_COMPANY,
              },
            ]}
            selectedValue={selectedDropshipAddressType}
            onChange={({ value }) => {
              dispatch(setSelectedDropshipAddressType(value));

              if (value != CHECKOUT_DROPSHIP_COMPANY) {
                dispatch(setCustomerDetails('companyName', undefined));
              } else {
                dispatch(setCustomerDetails('firstName', undefined));
                dispatch(setCustomerDetails('lastName', undefined));
              }
            }}
            label={translate('checkout.dropship.address-type')}
          />
          <CheckoutCustomerInfoForm
            showSignUp={false}
            allowAlternativeAddress={false}
          />
        </>
      )}
    </div>
  );
};

export default BusinessCustomerInfo;
